import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useReducedMotion } from "motion/react";
import Home from "../views/home";
import DesktopServices from "./desktop-services";
import DesktopWhyUs from "./desktop-why-us";
import DesktopContact from "./desktop-contact";
import { useHardwareAcceleration } from "@/hooks/use-hardware-acceleration";
import { scrollToSection } from "@/lib/scroll-to-section";

const pathToSection: Record<string, string> = {
  "/": "home",
  "/services": "services",
  "/why-us": "why-us",
  "/contact": "contact",
};

export default function DesktopPage() {
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  const hasHardwareAcceleration = useHardwareAcceleration();

  const isFirstRoute = useRef(true);

  useEffect(() => {
    const sectionId = pathToSection[location.pathname] ?? "home";
    // Deep links land instantly; in-app navigation glides or cuts.
    const animate =
      !isFirstRoute.current && !reduceMotion && hasHardwareAcceleration;
    isFirstRoute.current = false;
    const frame = window.requestAnimationFrame(() =>
      scrollToSection(sectionId, { animate })
    );

    return () => window.cancelAnimationFrame(frame);
  }, [hasHardwareAcceleration, location.pathname, reduceMotion]);

  return (
    <main className="relative z-10 w-full overflow-clip">
      <section
        id="home"
        data-desktop-section="home"
        className="mx-auto flex h-[calc(100dvh-6rem)] min-h-[680px] w-full max-w-6xl scroll-mt-24 overflow-x-visible overflow-y-clip px-4"
      >
        <Home />
      </section>
      <DesktopServices />
      <DesktopWhyUs />
      <DesktopContact />
    </main>
  );
}
